<template>
  <div id="multi-print-area" style="display: none;">
    <div
      class="multi-print-page"
      v-for="(user, index) in selectedUsersForPrint"
      :key="index"
    >
      <div class="sections">
        <div
          class="section1"
          :class="{
            noPhotoNoQr:
              (!user.printBadgeModel.showPhoto || !user.printBadgeModel.photo) &&
              !user.printBadgeModel.qr,
            withPhotoQr:
              user.printBadgeModel.showPhoto &&
              user.printBadgeModel.photo &&
              user.printBadgeModel.qr,
            qrOnly:
              (!user.printBadgeModel.showPhoto || !user.printBadgeModel.photo) &&
              user.printBadgeModel.qr,
            photoOnly:
              user.printBadgeModel.showPhoto &&
              user.printBadgeModel.photo &&
              !user.printBadgeModel.qr,
          }"
        >
          <!-- for section1: justify-content: center if (no photo && no qr) else if (photo && qr) OR (qr only) space-between; else (photo but no qr) none but add gap: 8px -->
          <img
            v-if="user.printBadgeModel.showPhoto && user.printBadgeModel.photo"
            class="user-img"
            :src="user.printBadgeModel.photo"
            alt=""
          />

          <div
            class="section1-text"
            :class="{
              noPhotoNoQr:
                (!user.printBadgeModel.showPhoto || !user.printBadgeModel.photo) &&
                !user.printBadgeModel.qr,
              withPhotoQr:
                user.printBadgeModel.showPhoto &&
                user.printBadgeModel.photo &&
                user.printBadgeModel.qr,
            }"
          >
            <!-- text-align:center if (no photo && no qr) OR (photo && qr) -->
            <span class="multi-print-text">{{ currentEntity.name.toUpperCase() }}</span>
            <span class="multi-print-text"
              >{{ $t(`signInOut.${user.printBadgeModel.loginMode}`)
              }}{{
                user.printBadgeModel.showTemperature &&
                user.printBadgeModel.loginMode != "Sign out"
                  ? " - " + user.printBadgeModel.tempValue
                  : ""
              }}</span
            >
            <span class="multi-print-text" style="font-weight: 800"
              >({{ getTodayDate() }})</span
            >
          </div>

          <div v-if="user.printBadgeModel.qr" class="qr-border">
            <img class="qr-img" alt="" :src="user.printBadgeModel.qr" />
          </div>
        </div>

        <div
          class="section2"
          :class="{
            noPhotoNoQr:
              (!user.printBadgeModel.showPhoto || !user.printBadgeModel.photo) &&
              !user.printBadgeModel.qr,
          }"
        >
          <!-- text-align: center if no photo && no qr -->
          <span
            v-if="user.printBadgeModel.showName"
            class="multi-print-text nowrap"
            :class="{
              'multi-print-text-with-fields':
                user.printBadgeModel.customFields &&
                user.printBadgeModel.customFields.length,
              'multi-print-text-without-fields':
                !user.printBadgeModel.customFields ||
                !user.printBadgeModel.customFields.length,
            }"
            >{{ user.printBadgeModel.fullName }}</span
          >
          <span
            v-if="user.printBadgeModel.showHost && user.printBadgeModel.hostName"
            class="multi-print-text nowrap"
            :class="{
              'multi-print-text-with-fields':
                user.printBadgeModel.customFields &&
                user.printBadgeModel.customFields.length,
              'multi-print-text-without-fields':
                !user.printBadgeModel.customFields ||
                !user.printBadgeModel.customFields.length,
            }"
            >{{ $t("common.host") }}: {{ user.printBadgeModel.hostName }}</span
          >
          <span
            v-if="
              user.printBadgeModel.showLateSignIn && user.printBadgeModel.lateSignInReason
            "
            class="multi-print-text nowrap"
            :class="{
              'multi-print-text-with-fields':
                user.printBadgeModel.customFields &&
                user.printBadgeModel.customFields.length,
              'multi-print-text-without-fields':
                !user.printBadgeModel.customFields ||
                !user.printBadgeModel.customFields.length,
            }"
            >{{ $t("signInOut.lateSignInLC") }}:
            {{ user.printBadgeModel.lateSignInReason }}</span
          >
          <span
            v-if="
              user.printBadgeModel.showEarlySignOut &&
              user.printBadgeModel.earlySignOutReason
            "
            class="multi-print-text nowrap"
            :class="{
              'multi-print-text-with-fields':
                user.printBadgeModel.customFields &&
                user.printBadgeModel.customFields.length,
              'multi-print-text-without-fields':
                !user.printBadgeModel.customFields ||
                !user.printBadgeModel.customFields.length,
            }"
            >{{ $t("signInOut.earlySignOutLC") }}:
            {{ user.printBadgeModel.earlySignOutReason }}</span
          >
        </div>

        <div class="section3">
          <div
            class="badge-section"
            v-if="
              user.printBadgeModel.customFields &&
              user.printBadgeModel.customFields.length
            "
          >
            <!-- hide badge-section if no customfields -->
            <div class="badge-separator"></div>
            <div class="badges">
              <div
                class="badge-block"
                v-for="(customField, index) in user.printBadgeModel.customFields"
                :key="index"
                style="margin-bottom: 5px"
              >
                <div class="badge-icon" style="background-color: black">
                  <i style="color: white" class="fa-sm" :class="customField.icon"></i>
                </div>

                <span
                  v-if="customField.type == 'stars' || customField.type == 'labels'"
                  >{{ Number(customField.value) }}</span
                >

                <span v-else-if="customField.type == 'smileys'">
                  {{ Number(customField.value) ? getRatingScaleData(customField).smileyText : customField.value }}
                </span>

                <span v-else-if="customField.type == 'toggleButton'">{{ +customField.value ? "Yes" : "No" }}</span>

                <span v-else>{{ customField.value }}</span>
              </div>
            </div>
          </div>
          <span
            v-if="user.printBadgeModel.showUserType"
            class="multi-print-text nowrap"
            style="margin-top: 8px"
            >{{ user.printBadgeModel.userType.toUpperCase() }}</span
          >
        </div>
      </div>

      <img
        v-if="
          user.printBadgeModel.showJourneyCompanyLogo && user.printBadgeModel.journeyLogo
        "
        class="entity-watermark multi-watermark img-watermark"
        :src="user.printBadgeModel.journeyLogo"
        alt=""
      />
      <img
        v-else-if="user.printBadgeModel.showJourneyCompanyLogo && currentEntity.logo"
        class="entity-watermark multi-watermark img-watermark"
        :src="currentEntity.logo"
        alt=""
      />
      <!-- <div v-else-if="user.printBadgeModel.showJourneyCompanyLogo" class="multi-watermark logo-watermark img-watermark">
        <svg
          width="143"
          height="144"
          viewBox="0 0 143 144"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M23.6041 127.582L17.2658 113.776L20.8825 110.159L31.4865 135.347L5.87402 125.168L9.53463 121.507L23.6041 127.582Z"
            fill="#787878"
          />
          <path
            d="M23.6044 127.584L17.266 113.778L20.8827 110.161L31.4867 135.349"
            fill="#787878"
          />
          <path
            d="M12.9605 117.234C14.2948 115.9 14.2543 113.696 12.8699 112.311C11.4855 110.927 9.28157 110.886 7.94725 112.221C6.61293 113.555 6.65351 115.759 8.03789 117.143C9.42227 118.528 11.6262 118.568 12.9605 117.234Z"
            fill="#787878"
          />
          <path
            d="M118.928 37.1829L106.159 24.7945L108.867 22.0856L126.824 40.0423L124.745 42.1215L104.062 38.8626L115.91 50.6525L113.172 53.3907L95.5799 35.7986L97.6591 33.7194L118.928 37.1829Z"
            fill="#787878"
          />
          <path
            d="M28.3378 102.828L25.6582 105.508L43.4933 123.343L46.1729 120.663L28.3378 102.828Z"
            fill="#787878"
          />
          <path
            d="M56.2932 103.402C57.5419 105.617 57.401 108.492 55.9065 110.746C55.6311 111.174 55.3095 111.526 54.9581 111.877C54.2699 112.565 53.4455 113.147 52.543 113.533C51.0037 114.16 49.3075 114.368 47.4236 114.094L47.8149 110.239C48.9665 110.425 50.0383 110.325 50.8964 109.953C51.6216 109.653 52.2235 109.143 52.5999 108.523C53.3113 107.478 53.4211 106.152 52.9121 105.233C52.326 104.179 51.0702 104.007 50.1009 104.004C48.5951 104.021 46.0597 104.004 45.8807 104L41.7061 104.043C40.4086 104.034 39.2553 103.759 38.2463 103.219C37.2676 102.709 36.463 101.933 35.9388 100.999C35.369 100.019 35.1398 98.9115 35.2226 97.735C35.3069 96.648 35.6598 95.5659 36.2845 94.6678C36.9216 93.6357 37.8761 92.8331 39.0298 92.3175C40.2729 91.8035 41.6561 91.6053 43.1804 91.7825L42.8189 95.6381C40.8314 95.4076 39.9235 96.3155 39.5467 96.905C39.0679 97.6269 38.9656 98.5495 39.3351 99.1826C39.5815 99.6047 40.143 100.137 41.5897 100.149L47.3157 100.135C48.151 100.15 49.18 100.154 49.9101 100.123C51.3557 100.075 52.6435 100.367 53.7426 100.939C54.8119 101.511 55.7071 102.347 56.2932 103.402Z"
            fill="#787878"
          />
          <path
            d="M48.5887 82.5783L45.9092 85.2578L63.7443 103.093L66.4239 100.413L48.5887 82.5783Z"
            fill="#787878"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M55.5586 75.6357L58.3846 72.8097C60.6542 70.5401 62.9291 70.1794 64.4073 70.2812C66.3932 70.4221 68.2746 71.3664 69.9305 73.0223C71.5864 74.6782 72.561 76.59 72.6716 78.5455C72.8037 80.054 72.4284 82.3436 70.1734 84.5985L67.7721 86.9999L73.8032 93.031L71.1236 95.7105L53.3037 77.8906L55.5586 75.6357ZM67.5443 75.4388C66.8455 74.74 65.6964 73.8838 64.3522 73.7696C63.1729 73.7031 62.0041 74.2035 60.8913 75.3163L58.4899 77.7177L65.2654 84.4932L67.6668 82.0919C68.7796 80.979 69.2952 79.8254 69.2288 78.6461C69.1297 77.3171 68.2583 76.1529 67.5443 75.4388Z"
            fill="#787878"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M89.2113 76.2273C87.7159 76.8112 86.1548 77.0658 84.559 77.0513C82.9479 77.0216 81.4063 76.7099 79.8732 76.0554C78.3553 75.416 76.9361 74.4654 75.7359 73.2652C74.5358 72.0651 73.6003 70.661 72.9306 69.1127C72.3064 67.6101 72.0093 66.0537 71.9346 64.4269C71.905 62.8159 72.1753 61.2999 72.7738 59.7898C73.3577 58.2945 74.2567 56.9093 75.4135 55.7526C76.5702 54.5958 77.9407 53.7114 79.4654 53.0983C80.9461 52.529 82.4622 52.2587 84.1025 52.2591C85.7287 52.304 87.271 52.6455 88.7737 53.2697C90.3219 53.9394 91.726 54.8749 92.9261 56.075C94.1263 57.2752 95.0617 58.6792 95.7163 60.2123C96.3556 61.7302 96.6972 63.2724 96.7268 64.8834C96.7419 66.5091 96.4721 68.055 95.9029 69.5357C95.2897 71.0604 94.4053 72.4309 93.2486 73.5877C92.0772 74.7591 90.7218 75.6586 89.2113 76.2273ZM75.8435 64.5287C75.8852 66.7961 76.79 68.9601 78.4307 70.6008C80.0562 72.2264 82.2354 73.1463 84.5028 73.188C86.7702 73.2298 88.9023 72.4041 90.4837 70.8228C92.0504 69.256 92.8907 67.1093 92.8489 64.8419C92.8072 62.5745 91.9025 60.4105 90.2617 58.7698C88.621 57.1291 86.457 56.2243 84.1896 56.1826C81.9223 56.1408 79.7901 56.9665 78.2087 58.5478C76.6426 60.1444 75.8017 62.2613 75.8435 64.5287Z"
            fill="#787878"
          />
          <path
            d="M127.251 8.95889L122.521 13.6884L137.834 29.0017L135.126 31.7105L119.812 16.3972L115.097 21.1121L112.591 18.6055L124.744 6.45225L127.251 8.95889Z"
            fill="#787878"
          />
          <path
            d="M90.9344 40.2306L88.2549 42.9102L106.09 60.7453L108.77 58.0657L90.9344 40.2306Z"
            fill="#787878"
          />
        </svg>
      </div> -->
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import smileysJson from "@/router/views/customFields/smileys.json";
export default {
  props: ["selectedUsersForPrint"],
  data() {
    return {
      smileysToShow: [
        ["sad", "happy"],
        ["sad", "poker", "happy"],
        ["sad", "poker", "semi-happy", "happy"],
        ["sad", "semi-sad", "poker", "semi-happy", "happy"],
        ["sad", "semi-sad", "poker", "semi-happy", "happy", "smile"],
        ["hesitate", "sad", "semi-sad", "poker", "semi-happy", "happy", "smile"],
        ["hesitate", "sad", "semi-sad", "poker", "semi-happy", "happy", "smile", "love"],
        [
          "cry",
          "hesitate",
          "sad",
          "semi-sad",
          "poker",
          "semi-happy",
          "happy",
          "smile",
          "love",
        ],
        [
          "frown",
          "cry",
          "hesitate",
          "sad",
          "semi-sad",
          "poker",
          "semi-happy",
          "happy",
          "smile",
          "love",
        ],
      ],
    };
  },
  computed: {
    ...mapGetters("authfack", ["currentEntity"]),
  },
  mounted() {
    console.log("selectedUsersForPrint", this.selectedUsersForPrint, this.currentEntity);
  },
  watch: {
    selectedUsersForPrint: {
      handler(val) {
        console.log("watch selectedUsersForPrint", val);
        val.forEach((user) => {
          if (user.printBadgeModel?.showTemperature) {
            const entityTemp = this.currentEntity.setting.find(
              (item) => item.name == "temperature_display_unit_for_company"
            );
            console.log("entityTemp", entityTemp, user.printBadgeModel.temperature);
            user.printBadgeModel.tempValue =
              user.printBadgeModel.temperature +
              (user.printBadgeModel.unitType == "f"
                ? ` °${this.$t("common.temperatureUnits.f")}`
                : ` °${this.$t("common.temperatureUnits.c")}`);
            if (entityTemp?.pivot?.value == "c" && user.printBadgeModel.unitType == "f") {
              // convert to c
              const degree = user.printBadgeModel.temperature;
              const deg = (degree - 32) * (5 / 9);
              const tempInC = Math.round(deg * 10) / 10;
              user.printBadgeModel.tempValue =
                tempInC + ` °${this.$t("common.temperatureUnits.c")}`;
            } else if (
              entityTemp?.pivot?.value == "f" &&
              user.printBadgeModel.unitType == "c"
            ) {
              // convert to f
              const degree = user.printBadgeModel.temperature * (9 / 5) + 32;
              const deg = Math.round(degree * 10) / 10;
              const tempInF = Math.round(deg * 10) / 10;
              user.printBadgeModel.tempValue =
                tempInF + ` °${this.$t("common.temperatureUnits.f")}`;
            }
          }
        });
      },
      deep: true,
    },
  },
  methods: {
    getTodayDate() {
      return moment().format("D MMMM - HH:mm");
    },
    getRatingScaleData(data) {
      const smileyColors = this.setSmileysColor(data.metadata[0].scale_count);
      const smileyText = this.setSmileysText(data.metadata[0].scale_count);
      const visibleSmiley = this.smileysToShow[data.metadata[0].scale_count - 2];
      return {
        smileySvg: smileysJson[visibleSmiley[+data.value - 1] + "Colored"],
        smileyColor: smileyColors[+data.value - 1],
        smileyText: smileyText[+data.value - 1],
      };
    },
    setSmileysColor(scaleCount) {
      let smileyColors = [];
      switch (scaleCount) {
        case 2:
          smileyColors = ["rgb(230, 10, 62)", "rgb(25, 179, 148)"];
          break;
        case 3:
          smileyColors = ["rgb(230, 10, 62)", "rgb(255, 152, 20)", "rgb(25, 179, 148)"];
          break;
        case 4:
          smileyColors = [
            "rgb(230, 10, 62)",
            "rgb(246, 104, 34)",
            "rgb(178, 161, 62)",
            "rgb(25, 179, 148)",
          ];
          break;
        case 5:
          smileyColors = [
            "rgb(230, 10, 62)",
            "rgb(242, 81, 41)",
            "rgb(255, 152, 20)",
            "rgb(140, 165, 84)",
            "rgb(25, 179, 148)",
          ];
          break;
        case 6:
          smileyColors = [
            "rgb(230, 10, 62)",
            "rgb(240, 66, 45)",
            "rgb(250, 123, 28)",
            "rgb(209, 157, 45)",
            "rgb(117, 168, 96)",
            "rgb(25, 179, 148)",
          ];
          break;
        case 7:
          smileyColors = [
            "rgb(230, 10, 62)",
            "rgb(238, 57, 48)",
            "rgb(246, 104, 34)",
            "rgb(255, 152, 20)",
            "rgb(178, 161, 62)",
            "rgb(101, 170, 105)",
            "rgb(25, 179, 148)",
          ];
          break;
        case 8:
          smileyColors = [
            "rgb(230, 10, 62)",
            "rgb(237, 50, 50)",
            "rgb(244, 91, 38)",
            "rgb(251, 131, 26)",
            "rgb(222, 155, 38)",
            "rgb(156, 163, 74)",
            "rgb(90, 171, 111)",
            "rgb(25, 179, 148)",
          ];
          break;
        case 9:
          smileyColors = [
            "rgb(230, 10, 62)",
            "rgb(236, 45, 51)",
            "rgb(242, 81, 41)",
            "rgb(248, 116, 30)",
            "rgb(255, 152, 20)",
            "rgb(197, 158, 52)",
            "rgb(140, 165, 84)",
            "rgb(82, 172, 116)",
            "rgb(25, 179, 148)",
          ];
          break;
        case 10:
          smileyColors = [
            "rgb(230, 10, 62)",
            "rgb(235, 41, 52)",
            "rgb(241, 73, 43)",
            "rgb(246, 104, 34)",
            "rgb(252, 136, 24)",
            "rgb(229, 155, 34)",
            "rgb(178, 161, 62)",
            "rgb(127, 167, 91)",
            "rgb(76, 173, 119)",
            "rgb(25, 179, 148)",
          ];
          break;
      }

      return smileyColors;
    },
    setSmileysText(scaleCount) {
      let smileyText = [];
      switch (scaleCount) {
        case 3:
          smileyText = ["Poor", "OK", "Good"];
          break;
        case 5:
          smileyText = ["Bad", "Poor", "OK", "Good", "Great"];
          break;
      }
      return smileyText;
    },
  },
};
</script>

<style lang="scss">
#multi-print-area {
  width: 255px;
  height: 170px;
  color: #000000;
}
.multi-print-page {
  position: relative;
  padding: 5px 10px;
  padding-bottom: 0;
  text-align: start;
  min-height: 95vh;

  .multi-print-text {
    font-size: 9px;
    font-weight: 700;
    //   margin-top: 12px;
    position: relative;
    z-index: 1;
    line-height: 1.2;
  }
  .multi-watermark {
    position: absolute;
    font-size: 48px;
    color: rgba(0, 0, 0, 0.1);
    z-index: 0;
    pointer-events: none;
    white-space: nowrap;
  }
  .logo-watermark {
    top: 5%;
    inset-inline-start: 20%;
  }
  .img-watermark {
    opacity: 15%;
    max-height: 142px;
    width: auto;
  }
  .qr-border {
    border: 3px solid black;
    padding: 3px;
    border-radius: 5px;
    //   width: 64px !important;
    max-width: 64px;
    height: 64px;
    position: relative;
    z-index: 1;
  }
  // .img-container {
  //   display: flex;
  //   justify-content: center;
  //   align-items: center;
  //   gap: 16px;
  .qr-img {
    width: 60px !important;
    height: 60px !important;
  }
  // }
  .user-img {
    border-radius: 5px;
    width: 64px !important;
    height: 64px !important;
  }

  .sections {
    display: flex;
    flex-direction: column;
    gap: 7px;
  }

  .section1 {
    display: flex;
  }

  .section1.noPhotoNoQr {
    justify-content: center;
  }

  .section1.withPhotoQr,
  .section1.qrOnly {
    justify-content: space-between;
  }

  .section1.photoOnly {
    gap: 8px;
  }

  .section1-text.noPhotoNoQr,
  .section1-text.withPhotoQr {
    text-align: center;
  }

  .section1-text,
  .section2 {
    display: flex;
    flex-direction: column;
    //   gap: 11px;
  }

  .section1-text {
    height: 64px;
    justify-content: space-between;
  }

  .section2 {
    //   display: flex;
    //   flex-direction: column;
    //   gap: 8px;
    min-height: 60px;
    // align-items: center;
    justify-content: center;
    .multi-print-text-without-fields {
      margin-bottom: 8px;
    }
    .multi-print-text-with-fields {
      margin-bottom: 8px;
    }
  }

  .section2.noPhotoNoQr {
    text-align: center;
  }

  .section3 {
    text-align: center;
    gap: 11px;
    display: flex;
    flex-direction: column;
  }

  .nowrap {
    white-space: nowrap;
  }

  .badge-separator {
    border-top: 0.75px solid #000000;
  }

  .badge-section {
    height: 30px;
  }

  .badges {
    display: flex;
    flex-wrap: wrap;
    font-size: 9px;
    align-items: center;
    // column-gap: 13px;
    // row-gap: 4px;
    // height: 35px;
  }

  .badge-block {
    display: flex;
    align-items: center;
    gap: 3px;
    flex: 0 0 50%;
  }

  .badge-icon {
    width: 15px;
    height: 15px;
    background: #000000;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 2px;
  }
}
</style>
